import { ModalSearchListener } from "../../../components/modal-search/modal-search-listener";
import type { SearchBrandModalHandler } from "./search-brand-modal-handler";

export interface SearchBrandModalListenerParams {
    rootEl: Document | HTMLElement;
    overlayEl: HTMLElement;
    modalEl: HTMLElement;
    closeBtnEl: HTMLElement | null;
    popularRootEl: HTMLElement;
    allRootEl: HTMLElement;
    filterInputEl: HTMLInputElement | null;
    handler: SearchBrandModalHandler;
}

export class SearchBrandModalListener {
    public static bindShowAllToggle(toggleEl: HTMLInputElement, onChange: () => void): void {
        toggleEl.addEventListener("change", onChange);
    }

    public static setup(params: SearchBrandModalListenerParams): void {
        const { rootEl, overlayEl, modalEl, closeBtnEl, popularRootEl, allRootEl, filterInputEl, handler } = params;

        ModalSearchListener.setup({
            rootEl,
            scopeKey: "search-brand-modal",
            overlayEl,
            modalEl,
            closeBtnEl,
            filterInputEl,
            actionRootEls: [popularRootEl, allRootEl],
            base: handler.getBase(),
        });
    }
}
